// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session-warning-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  justify-content: center;
  align-items: center;
}
.session-warning-overlay.active {
  display: flex;
}

.session-warning-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 420px;
  width: 90%;
  overflow: hidden;
}

.session-warning-icon {
  display: flex;
  justify-content: center;
  padding: 30px 20px 10px;
}
.session-warning-icon svg {
  width: 64px;
  height: 64px;
}
.session-warning-icon svg circle, .session-warning-icon svg path {
  stroke: #ffc107;
}
.session-warning-icon svg circle:last-child {
  fill: #ffc107;
}

.session-warning-header {
  padding: 10px 24px;
  text-align: center;
}
.session-warning-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
}

.session-warning-body {
  padding: 20px 24px;
  text-align: center;
}
.session-warning-body .timer-display {
  margin: 20px 0;
  padding: 16px;
  background: #f8f9fa;
  border: 2px solid #e9ecef;
  border-radius: 8px;
}
.session-warning-body .timer-display .timer-value {
  font-size: 2.5rem;
  font-weight: 600;
  color: #495057;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
.session-warning-body .warning-message {
  margin: 16px 0 0;
  font-size: 1rem;
  color: #6c757d;
  line-height: 1.5;
}

.session-warning-footer {
  padding: 0 24px 24px;
  display: flex;
  gap: 12px;
}
.session-warning-footer button {
  flex: 1;
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.session-warning-footer button svg {
  width: 16px;
  height: 16px;
}
.session-warning-footer button.btn-continue {
  background: var(--undp-jtf-primary-color, #0d6efd);
  color: white;
}
.session-warning-footer button.btn-continue:hover {
  opacity: 0.9;
}
.session-warning-footer button.btn-continue:active {
  opacity: 0.8;
}
.session-warning-footer button.btn-logout {
  background: white;
  color: var(--undp-jtf-text-color, #6c757d);
  border: 1px solid #dee2e6;
}
.session-warning-footer button.btn-logout:hover {
  background: #f8f9fa;
}
.session-warning-footer button.btn-logout:active {
  background: #e9ecef;
}

@media (max-width: 600px) {
  .session-warning-container {
    width: 95%;
  }
  .session-warning-body .timer-display .timer-value {
    font-size: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/session-warning/session-warning-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;AACJ;;AAGA;EACE,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;AAAF;AAEE;EACE,WAAA;EACA,YAAA;AAAJ;AAEI;EACE,eAAA;AAAN;AAGI;EACE,aAAA;AADN;;AAMA;EACE,kBAAA;EACA,kBAAA;AAHF;AAKE;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,kBAAA;AAJF;AAME;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAJJ;AAMI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,4DAAA;AAJN;AAQE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AANJ;;AAUA;EACE,oBAAA;EACA,aAAA;EACA,SAAA;AAPF;AASE;EACE,OAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAPJ;AASI;EACE,WAAA;EACA,YAAA;AAPN;AAUI;EACE,kDAAA;EACA,YAAA;AARN;AAUM;EACE,YAAA;AARR;AAWM;EACE,YAAA;AATR;AAaI;EACE,iBAAA;EACA,0CAAA;EACA,yBAAA;AAXN;AAaM;EACE,mBAAA;AAXR;AAcM;EACE,mBAAA;AAZR;;AAkBA;EACE;IACE,UAAA;EAfF;EAkBA;IACE,eAAA;EAhBF;AACF","sourcesContent":[".session-warning-overlay {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 9999;\n  justify-content: center;\n  align-items: center;\n\n  &.active {\n    display: flex;\n  }\n}\n\n.session-warning-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  max-width: 420px;\n  width: 90%;\n  overflow: hidden;\n}\n\n.session-warning-icon {\n  display: flex;\n  justify-content: center;\n  padding: 30px 20px 10px;\n\n  svg {\n    width: 64px;\n    height: 64px;\n\n    circle, path {\n      stroke: #ffc107;\n    }\n\n    circle:last-child {\n      fill: #ffc107;\n    }\n  }\n}\n\n.session-warning-header {\n  padding: 10px 24px;\n  text-align: center;\n\n  h3 {\n    margin: 0;\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: #333;\n  }\n}\n\n.session-warning-body {\n  padding: 20px 24px;\n  text-align: center;\n\n  .timer-display {\n    margin: 20px 0;\n    padding: 16px;\n    background: #f8f9fa;\n    border: 2px solid #e9ecef;\n    border-radius: 8px;\n\n    .timer-value {\n      font-size: 2.5rem;\n      font-weight: 600;\n      color: #495057;\n      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    }\n  }\n\n  .warning-message {\n    margin: 16px 0 0;\n    font-size: 1rem;\n    color: #6c757d;\n    line-height: 1.5;\n  }\n}\n\n.session-warning-footer {\n  padding: 0 24px 24px;\n  display: flex;\n  gap: 12px;\n\n  button {\n    flex: 1;\n    padding: 10px 16px;\n    border: none;\n    border-radius: 6px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n\n    svg {\n      width: 16px;\n      height: 16px;\n    }\n\n    &.btn-continue {\n      background: var(--undp-jtf-primary-color, #0d6efd);\n      color: white;\n\n      &:hover {\n        opacity: 0.9;\n      }\n\n      &:active {\n        opacity: 0.8;\n      }\n    }\n\n    &.btn-logout {\n      background: white;\n      color: var(--undp-jtf-text-color, #6c757d);\n      border: 1px solid #dee2e6;\n\n      &:hover {\n        background: #f8f9fa;\n      }\n\n      &:active {\n        background: #e9ecef;\n      }\n    }\n  }\n}\n\n@media (max-width: 600px) {\n  .session-warning-container {\n    width: 95%;\n  }\n\n  .session-warning-body .timer-display .timer-value {\n    font-size: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
